import { useRef, ChangeEvent } from 'react';

interface HiddenFileInputProps {
    accept?: string;
    onChange: (file: File) => void;
    onTrigger: (triggerUpload: () => void) => void;
}

export const HiddenFileInput = ({ accept, onChange, onTrigger }: HiddenFileInputProps) => {
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const triggerUpload = () => {
        fileInputRef.current?.click();
    };

    onTrigger(triggerUpload);

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        onChange(file);

        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    return (
        <input ref={fileInputRef} type="file" accept={accept} style={{ display: 'none' }} onChange={handleFileChange} />
    );
};
